import { frontendURL } from '../../../../helper/URLHelper';
const SettingsWrapper = () => import('../Wrapper.vue');
const Patients = () => import('./Index.vue');
const NewPatient = () => import('./NewPatient.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/patient-management'),
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: SettingsWrapper,
      props: {
        headerTitle: 'PATIENT_MANAGEMENT.TITLE',
        icon: 'people-team',
      },
      children: [
        {
          path: '',
          name: 'patient_management',
          component: Patients,
          meta: {
            permissions: ['administrator', 'agent', 'doctor'],
          },
        },
        {
          path: 'new/:contactId?',
          name: 'new_patient',
          component: NewPatient,
          meta: {
            permissions: ['administrator', 'agent', 'doctor'],
          },
        },
      ],
    },
  ],
};
